import React, { useContext, useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
import { ContextoAdminProtocolo } from './PrincipalAdminProtocolo';
const server = process.env.REACT_APP_SERVER;
function CrearEditProtocolo() {
    const { regional, actualizar, setActualizar, info, setModalShow, areas, idArea } = useContext(ContextoAdminProtocolo);
    const [categorias, setCategorias] = useState([]);
    const [nameCat, setNameCat] = useState('');
    const [idCategoria, setIdCategoria] = useState(-1);
    const [descripcion, setDescripcion] = useState('');
    const [area, setArea] = useState(-1);
    const [newCateg, setNewCate] = useState(false);
    const [areasSelect, setAreasSelect] = useState([])
    const [bloquearAgregar, setBloquearAgregar] = useState(false);
    const guardarDatos = () => {
        if (descripcion !== '' && areasSelect.length !== 0) {
            fetch(`${server}/protocolos/addEditProtocolo`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    regional, descripcion, "area":areasSelect, idEmpleado: JSON.parse(localStorage.getItem('info')).ID_EMPLEADO, info, idCategoria
                })
            })
                .then(res => res.json())
                .then(data => {
                    if (data.ok) {
                        setActualizar(!actualizar);
                        setModalShow(false);
                    } else {
                        MsgUtils.msgError(data.error)
                    }
                })
                .catch(err => MsgUtils.msgError(err));
        } else {
            MsgUtils.msgError("Complete la informacion del nuevo protocolo")
        }
    }
    function guardarCategoria() {
        if (nameCat !== '') {
            var aux = categorias.filter((item) => item.NOMBRE == nameCat);
            if (aux.length == 0) {
                fetch(`${server}/protocolos/addCategoriaProtocolo`, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        regional, 'V_NOMBRE': nameCat, 'V_ID': 0, 'V_ID_AREA': area
                    })
                })
                    .then(res => res.json())
                    .then(data => {
                        if (data.ok) {
                            getCategoriaProtocolo();
                        } else {
                            MsgUtils.msgError(data.error)
                        }
                    })
                    .catch(err => MsgUtils.msgError(err));
            } else {
                MsgUtils.msgError("Categoria Con mismo Nombre, no permitido !");
            }
        } else {
            MsgUtils.msgError("Ingrese el nombre de la Nueva Categoria");
        }
    }
    function getCategoriaProtocolo() {
        fetch(`${server}/protocolos/getCategoriaProtocolo`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    setCategorias(data.ok);
                    setNewCate(false);
                } else {
                    MsgUtils.msgError(data.error)
                }
            })
            .catch(err => MsgUtils.msgError(err));
    }
    function agregarAreaSeleccionada(){
          if (area == 0) {
            const areaTodos = {
                ID_CATEGORIA: 0,
                CATEGORIA: 'TODOS'
            };

            setAreasSelect([areaTodos]);
            setBloquearAgregar(true);
            return;
            }
        if(area!=-1){
            var filtroArea = areas.filter((item)=>item.ID_CATEGORIA==area);
            var hayEnlista = areasSelect.filter((item)=>item.ID_CATEGORIA==area);
            console.log(hayEnlista)
            if (hayEnlista.length===0){
                setAreasSelect([...areasSelect,filtroArea[0]])
            }else{
                MsgUtils.msgError("El area que quiere agregar ya esta en lista, no se puede repetir")
            }
        }
        else{
            MsgUtils.msgError("Selecciona area para agregar, por favor...")
        }
        
    }
    function eliminarAreaProtocolo(valor){
        var datos = areasSelect.filter(item=>item.ID_CATEGORIA!=valor.ID_CATEGORIA);
        setAreasSelect(datos);
    }
    useEffect(() => {
        console.log(info)
        if (info.ID_PROTOCOLO !== undefined) {
            setDescripcion(info.DESCRIPCION);
            setIdCategoria(info.ID_CATEGORIA == null ? -1 : info.ID_CATEGORIA);
            var areasSelec = info.ID_AREA.split(':');
            console.log(areasSelec)
            var areasFiltrada = areas.filter((item)=>areasSelec.indexOf(""+item.ID_CATEGORIA)!==-1)
            console.log(areasFiltrada)
            setAreasSelect(areasFiltrada)
        }
        getCategoriaProtocolo();
    }, [])
    return (
        <div className='container-fluid py-2'>
            <div className="mb-3">
                <label className="form-label text-light">Descripción</label>
                <input type="text" className="form-control form-control-sm" value={descripcion} onChange={(e) => setDescripcion(e.target.value)} />
            </div>
            <div className='mb-3'>
                <label className='form-label text-light'>Departamento</label>
                <div className='btn-group btn-group-sm mb-3'>
                    <select className="form-select form-select-sm btn-secondary "
                        style={{ minWidth: '135px', maxWidth: '135px' }}
                        value={area} onChange={(e) => setArea(e.target.value)}>
                        <option value={-1}>NINGUNO</option>
                        <option value={0}>TODOS</option>
                        {areas.map((item, index) => {
                            return (
                                <option key={index} value={item.ID_CATEGORIA}>{item.CATEGORIA}</option>
                            )
                        })}
                    </select>
                    <button className='btn btn-sm btn-success mx-2' style={{ minWidth: '110px', maxWidth: '110px' }}
                    onClick={()=>agregarAreaSeleccionada()} disabled={bloquearAgregar}>
                        <i className="fa-solid fa-circle-plus"></i> Agregar
                    </button>
                </div>
                <div className=''>
                {areasSelect.map((item, index) => {
                    return (
                        <div className="badge rounded-pill bg-light text-dark position-relative mx-2 mb-2" key={index}>
                            {item.CATEGORIA}
                            <button onClick={()=>eliminarAreaProtocolo(item)}
                            className="position-absolute top-0 start-100 translate-middle bg-danger border border-light rounded-circle fw-bold text-light m-0 p-1">
                                X
                            </button>
                        </div>
                    )
                })}
                </div>
            </div>
            {/*
            <div className='mb-3'>
                <label className='form-label text-light'>
                    Categoria
                    {newCateg == false && <button className='btn btn-sm text-success fa-xl' onClick={() => setNewCate(true)}>
                        <i className="fa-solid fa-folder-plus"></i>
                    </button>}
                </label>
                {newCateg == false && <select className="form-select form-select-sm btn-secondary "
                    value={idCategoria} onChange={(e) => setIdCategoria(e.target.value)}>
                    <option value={-1}>NINGUNO</option>
                    {categorias.map((item, index) => {
                        if (item.ID_AREA == area) {
                            return (
                                <option key={index} value={item.ID_CATEGORIA}>{item.NOMBRE}</option>
                            )
                        }
                    })}
                </select>}
                {newCateg == true &&
                    <div className="input-group mb-3">
                        <input type="text" className="form-control"
                            placeholder="Nombre Categoria"
                            value={nameCat} onChange={(e) => setNameCat(e.target.value.toUpperCase())} />
                        <button className='btn btn-sm btn-success ' onClick={() => guardarCategoria()}>
                            Guardar
                        </button>
                    </div>}
            </div>*/}
            {newCateg == false && <button className='btn btn-sm btn-success w-100' onClick={() => guardarDatos()}>
                Guardar
            </button>}
        </div>
    )
}

export default CrearEditProtocolo
